import type { AxiosInstance } from "axios";
import { httpClient, resetCsrfToken } from "./httpClient";
import type {
  MeResponse,
  SelectTenantResponse,
  SessionPayload,
} from "./types";

export function createAuthApi(client: AxiosInstance = httpClient) {
  return {
    async fetchCsrf(): Promise<string> {
      const { data } = await client.get<{ csrfToken: string }>("/auth/csrf");
      return data.csrfToken;
    },

    async login(email: string, password: string): Promise<SessionPayload> {
      const { data } = await client.post<SessionPayload>("/auth/login", {
        email,
        password,
      });
      return data;
    },

    async me(): Promise<MeResponse> {
      const { data } = await client.get<MeResponse>("/auth/me");
      return data;
    },

    async selectTenant(tenantId: string): Promise<SelectTenantResponse> {
      const { data } = await client.post<SelectTenantResponse>(
        "/auth/select-tenant",
        { tenantId },
      );
      return data;
    },

    async logout(): Promise<void> {
      try {
        await client.post("/auth/logout", {});
      } finally {
        resetCsrfToken();
      }
    },
  };
}

export const authApi = createAuthApi();
